import DashboardLayout from "@/components/dashboard/DashboardLayout";
import StatusPagesList from "@/components/status_pages/StatusPagesList";

export default function StatusPagesPage() {
  return (
    <DashboardLayout
      activePath="/dashboard/status_pages"
      title="Status Pages"
      breadcrumbs={[{ label: "Status Pages" }]}
    >
      <div className="mx-auto max-w-6xl px-4 py-8">
        <StatusPagesList />
      </div>
    </DashboardLayout>
  );
}
